// Module
var code = "<react-component name=\"AbsentAttendance\"></react-component>\n";
// Exports
module.exports = code;